import gql from 'graphql-tag';
import { CUSTOMER_FRAGMENT } from '../fragments/customer';

/**
 * 自定义页面数据
 */
export const fetchCustomPageDocument = gql`
  query customPage($customPageId: ID, $options: CustomPageListOptions, $isPreview: Boolean) {
    customPage(customPageId: $customPageId, options: $options, isPreview: $isPreview) {
      id
      createdAt
      updatedAt
      type
      title
      showNotice
      showSearch
      showPopup
      showCustomerService
      showShoppingCart
      popup {
        id
        title
        pictureResource {
          imgHeight
          imgWidth
          imgUrl
          alt
          jump {
            startAxisX
            startAxisY
            endPointAxisX
            endPointAxisY
            jumpType
            jumpValue
          }
        }
        deliveryStartTime
        deliveryEndTime
        pushFrequency
      }
      shareImg
      shareTitle
      enable
      components {
        id
        createdAt
        updatedAt
        type
        data {
          backGroundImage {
            ...PictureResource
          }
          backGroundColor
          layoutType
          pictures {
            ...PictureResource
          }
          productGroup {
            menuCollection {
              menuName
              collectionId
            }
            groupType
          }
          productItems {
            showType
            ids
          }
          productCategoryList {
            banner {
              ...PictureResource
            }
            title
            subCategory {
              banner {
                ...PictureResource
              }
              title
            }
          }
          countdownEndTime
          backGroundColor
          fontColor
          borderColor
          borderInsideColor
          description
        }
        sort
        remark
        enable
      }
    }
  }
  fragment PictureResource on PictureResource {
    imgHeight
    imgWidth
    imgUrl
    videoUrl
    alt
    jump {
      ...Jump
    }
  }
  fragment Jump on Jump {
    startAxisX
    startAxisY
    endPointAxisX
    endPointAxisY
    jumpType
    jumpValue
    jumpName
  }
`;

/**
 * 获取商品分类的商品数据
 */
export const fetchSeriesProductsDocument = gql`
  query seriesProducts($collectionId: ID!, $options: ProductListOptions) {
    seriesProducts(collectionId: $collectionId, options: $options) {
      items {
        id
        name
        enabled
        productTotalStock
        pointsExchangeInfo {
          id
          allowPurchaseAtOriginalPrice
          exchangeConditionType
          pointExchange {
            points
            cash
            exchangeTotal
          }
        }
        productPurchasePermission {
          id
          productId
          isMembershipPlanPurchase
          membershipPlans {
            id
          }
          guideMembershipPlanId
        }
        featuredAsset {
          source
        }
        memberPriceActivityAmount {
          minDiscount
          maxDiscount
          minMemberPriceAmount
          maxMemberPriceAmount
          memberPriceProductVariant {
            memberPriceAmount
            productVariantId
            memberDiscount
            discountType
          }
        }
        participatingActivities {
          id
          createdAt
          updatedAt
          endsAt
          couponCode
          perCustomerUsageLimit
          enabled
          customFields {
            type
            activityName
          }
        }
        customFields {
          price
          markingPrice
          limitType
          limitCount
          putOnSaleType
          putOnSaleTime
          isVipProduct
          isHiddenCart
          virtualTargetType
        }
      }
      totalItems
    }
  }
`;

/**
 * 查询自己的分销员信息
 */
export const fetchGetDistributorDocument = gql`
  query getDistributor {
    getDistributor {
      id
      createdAt
      updatedAt
      name
      phone
      customer {
        ...Customer
      }
      orderTotal
      customerCount
      effectiveCustomerNum
    }
  }
  ${CUSTOMER_FRAGMENT}
`;

/**
 * 绑定分销员
 */
export const fetchBoundDistributorDocument = gql`
  mutation boundDistributor($distributorId: ID!) {
    boundDistributor(distributorId: $distributorId)
  }
`;

/**
 * 分享信息
 */
export const fetchDistributorSharingDocument = gql`
  query distributorSharing($input: DistributorSharingInput!) {
    distributorSharing(input: $input)
  }
`;

/**
 * 获取通告信息
 */
export const fetchGetAnnouncementDocument = gql`
  query getAnnouncement {
    getAnnouncement {
      id
      createdAt
      updatedAt
      value
    }
  }
`;

// 引导页面用户下单上报数据
export const fetchOrderTrackingDocument = gql`
  mutation addOrderTracking(
    $orderId: ID!
    $trackingPageType: TrackingPageType!
    $trackingPageId: ID
  ) {
    addOrderTracking(
      orderId: $orderId
      trackingPageType: $trackingPageType
      trackingPageId: $trackingPageId
    ) {
      id
      createdAt
      updatedAt
      customerId
      orderId
      orderAmount
      pageId
      pageType
      channelId
    }
  }
`;

/** 解析code - 分享分销 */
export const fetchDesDeCodeDocument = gql`
  query desDecode($input: String!) {
    desDecode(input: $input) {
      shareType
      shareValue
      distributorId
      isDetail
      isPreview
      path
    }
  }
`;
